import { ExternalLink } from "lucide-react";

import { IgTypography } from "@intelligems/ig-theme";
import IgMobileDialog from "@intelligems/ig-theme/mobile/IgMobileDialog";
import { endingThemeTest } from "@src/utils/linkSheet";
import { openNewTab } from "@src/utils/openNewTab";

interface MobileThemeAcknowledgementModalProps {
  open: boolean;
  onClose: () => void;
  onAcknowledge: () => void;
  action: "pause" | "end";
  loading?: boolean;
}

export const MobileThemeAcknowledgementModal = ({
  open,
  onClose,
  onAcknowledge,
  action,
  loading = false,
}: MobileThemeAcknowledgementModalProps) => {
  return (
    <IgMobileDialog
      open={open}
      onClose={onClose}
      title="Important Reminder"
      yesButtonText="I Acknowledge"
      noButtonText={null}
      handleYesClick={onAcknowledge}
      loading={loading}
    >
      {/* Warning Text */}
      <IgTypography variant="body2">
        When {action === "pause" ? "pausing" : "ending"} a theme test, do not
        delete any theme present in the test for at least a month.
      </IgTypography>

      {/* Help Link */}
      <IgTypography
        variant="body2"
        sx={{
          color: "primary.main",
          cursor: "pointer",
          textDecoration: "underline",
        }}
        onClick={() => openNewTab(endingThemeTest)}
      >
        How to End a Theme Test{" "}
        <ExternalLink
          size={12}
          style={{ display: "inline", verticalAlign: "middle" }}
        />
      </IgTypography>
    </IgMobileDialog>
  );
};
